import { render, staticRenderFns } from "./TemplateBlock.vue?vue&type=template&id=0239dee5&scoped=true&xmlns%3Av=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./TemplateBlock.vue?vue&type=script&lang=js&"
export * from "./TemplateBlock.vue?vue&type=script&lang=js&"
import style0 from "../Style/template-block.scss?vue&type=style&index=0&id=0239dee5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0239dee5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0239dee5')) {
      api.createRecord('0239dee5', component.options)
    } else {
      api.reload('0239dee5', component.options)
    }
    module.hot.accept("./TemplateBlock.vue?vue&type=template&id=0239dee5&scoped=true&xmlns%3Av=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('0239dee5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/TemplateBlock.vue"
export default component.exports